export enum DatasetFieldType {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    NUMERIC = 'NUMERIC',
    DATE_TIME = 'DATE_TIME'
}
